/* Quick filter journey events for Dash0: impression → filter → product → add to cart → checkout.
   Events are joined per session.id in Dash0; nothing is sent without analytics consent. */
(function () {
  var QF_USED_KEY = 'dfyne_qf_used';

  function canTrack() {
    var consent = window.DFYNE && window.DFYNE.consent;
    return !!(consent && consent.allowed('analytics') && typeof window.dash0 === 'function');
  }

  function pageType() {
    var match = document.body.className.match(/\btemplate-([a-z0-9_-]+)/);
    return match ? match[1] : 'other';
  }

  function pageCategory() {
    var match = window.location.pathname.match(/\/collections\/([^/]+)/);
    if (match) return match[1];
    return pageType() === 'search' ? 'search' : '';
  }

  function qfUsed() {
    try { return sessionStorage.getItem(QF_USED_KEY) || ''; } catch (e) { return ''; }
  }

  function text(el) {
    return el ? el.textContent.trim().replace(/\s+/g, ' ').slice(0, 120) : '';
  }

  function send(name, title, attributes) {
    if (!canTrack()) return;
    try {
      var attrs = {
        'dfyne.page.type': pageType(),
        'dfyne.page.category': pageCategory(),
        'dfyne.qf.used': qfUsed() ? 'true' : 'false'
      };
      Object.keys(attributes || {}).forEach(function (key) {
        if (attributes[key] !== '' && attributes[key] != null) attrs[key] = String(attributes[key]);
      });
      window.dash0('sendEvent', name, { title: title, attributes: attrs });
    } catch (e) { /* Analytics must not interrupt the page. */ }
  }

  function decodePairs(pairs) {
    try { return decodeURIComponent(pairs.replace(/\+/g, ' ')); } catch (e) { return pairs; }
  }

  function activeQuickFilter() {
    return document.querySelector('[data-quick-filters] .js-quick-filter.is-active');
  }

  function quickFilterDetails(control) {
    var row = control.closest('[data-quick-filters]');
    var chips = row ? Array.prototype.slice.call(row.querySelectorAll('.js-quick-filter')) : [];
    return {
      'dfyne.filter.label': text(control.querySelector('.quick-filter__label')),
      'dfyne.filter.pairs': decodePairs(control.getAttribute('data-quick-filter-pairs') || ''),
      'dfyne.filter.position': chips.indexOf(control) + 1
    };
  }

  function writeCartAttribute() {
    var used = qfUsed();
    if (!used || !canTrack()) return;
    nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { __qf_used: used } })
    }).catch(function () {});
  }

  function markQuickFilterUsed(control) {
    if (qfUsed() || !canTrack()) return;
    try { sessionStorage.setItem(QF_USED_KEY, text(control.querySelector('.quick-filter__label')) || 'yes'); } catch (e) { return; }
    writeCartAttribute();
  }

  var impressionContext = null;

  function currentContext() {
    return window.location.pathname + '|' + (new URLSearchParams(window.location.search).get('q') || '');
  }

  function sendImpressions() {
    impressionContext = currentContext();
    document.querySelectorAll('[data-quick-filters]').forEach(function (row) {
      var chips = row.querySelectorAll('.js-quick-filter');
      var available = row.querySelectorAll('.js-quick-filter:not([aria-disabled="true"])');
      send('dfyne.qf.impression', 'Quick filters shown', {
        'dfyne.qf.chips': chips.length,
        'dfyne.qf.chips_available': available.length,
        'dfyne.qf.labels': Array.prototype.map.call(chips, function (chip) {
          return text(chip.querySelector('.quick-filter__label'));
        }).join(' | ').slice(0, 500)
      });
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.grid-product a[href*="/products/"]');
    if (!link) return;
    var type = pageType();
    if (type !== 'collection' && type !== 'search') return;
    var card = link.closest('.grid-product');
    var cards = Array.prototype.slice.call(document.querySelectorAll('#CollectionAjaxContent .grid-product'));
    var active = activeQuickFilter();
    send('dfyne.product.click', 'Product click: ' + (card.getAttribute('data-product-handle') || ''), {
      'dfyne.product.handle': card.getAttribute('data-product-handle'),
      'dfyne.product.type': card.getAttribute('data-product-type'),
      'dfyne.product.position': cards.indexOf(card) + 1 || '',
      'dfyne.qf.active': active ? 'true' : 'false',
      'dfyne.qf.active_label': active ? text(active.querySelector('.quick-filter__label')) : ''
    });
  }, true);

  document.addEventListener('submit', function (e) {
    var button = e.submitter;
    if (!button || button.name !== 'checkout') return;
    send('dfyne.checkout.click', 'Checkout clicked', {
      'dfyne.checkout.source': button.closest('#CartDrawer') ? 'drawer' : 'cart_page'
    });
  }, true);

  function sendCartAdd(response) {
    response.clone().json().then(function (data) {
      var items = data && data.items ? data.items : [data];
      items.forEach(function (item) {
        if (!item || !item.product_id) return;
        send('dfyne.cart.add', 'Added to cart: ' + (item.handle || item.product_id), {
          'dfyne.product.handle': item.handle,
          'dfyne.product.type': item.product_type,
          'dfyne.product.variant_id': item.variant_id,
          'dfyne.cart.quantity': item.quantity,
          'dfyne.cart.price': item.final_price != null ? (item.final_price / 100).toFixed(2) : ''
        });
      });
      writeCartAttribute();
    }).catch(function () {});
  }

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input) {
    var request = nativeFetch.apply(null, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('/cart/add') !== -1) {
      request.then(function (response) { if (response.ok) sendCartAdd(response); }).catch(function () {});
    }
    return request;
  };

  window.DFYNE = window.DFYNE || {};
  window.DFYNE.journey = {
    send: send,
    quickFilterDetails: quickFilterDetails,
    markQuickFilterUsed: markQuickFilterUsed
  };

  function sendImpressionsWhenAllowed() {
    var consent = window.DFYNE && window.DFYNE.consent;
    if (consent) consent.when('analytics', sendImpressions);
  }

  // A new in-page search swaps in a new row without a page load.
  document.addEventListener('collection:reloaded', function () {
    if (impressionContext !== null && impressionContext !== currentContext()) sendImpressions();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sendImpressionsWhenAllowed);
  } else {
    sendImpressionsWhenAllowed();
  }
})();
